import React from 'react'
import { Navbar, Footer } from "../../components"
import { PremiumCalc } from "."
export default function SignUp() {
  return (
    <div className='emas__signup'>
        <Navbar />
        <PremiumCalc />
        <Footer />
    </div>
  )
}
